import { IUpdateDisciplinasArquivosUseCase } from "../../../presentation/useCases/update/update_disciplinas_arquivos_use_case";
import { UpdateDisciplinasArquivosRequestModel, UpdateDisciplinasArquivosResponseModel } from "../../models/disciplina_arquivo_models";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * UpdateDisciplinasArquivosUseCase
 */

export class UpdateDisciplinasArquivosUseCase implements IUpdateDisciplinasArquivosUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async updateDisciplinasArquivos(model: UpdateDisciplinasArquivosRequestModel): Promise<UpdateDisciplinasArquivosResponseModel> {
    return await this.repository.updateDisciplinaArquivo(model);
  }
}
